import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HowToStepsComponent } from './how-to-steps/how-to-steps.component';
import { LocalizationComponent } from './localization/localization.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RewardTeaserComponent } from './reward-teaser/reward-teaser.component';
import { SupportComponent } from './support/support.component';
import { SurveyScriptComponent } from './survey-script/survey-script.component';
import { SafeHtmlPipe } from 'src/app/core/pipe/safehtml';
import { CookieComponent } from './support/cookie/cookie.component';
import { SupportRulesComponent } from './support/support-rules/support-rules.component';
import { SupportPolicyComponent } from './support/support-policy/support-policy.component';
import { LegalModalsComponent } from './legal-modals/legal-modals.component';



@NgModule({
  declarations: [HeaderComponent,
    FooterComponent,
    HowToStepsComponent,
    LocalizationComponent,
    RewardTeaserComponent,
    SupportComponent,
    SurveyScriptComponent,
    SafeHtmlPipe,
    CookieComponent,
    SupportRulesComponent,
    SupportPolicyComponent,
    LegalModalsComponent,
  
    ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [HeaderComponent,
    FooterComponent,
    HowToStepsComponent,
    LocalizationComponent,
    RewardTeaserComponent,
    SupportComponent,
    SurveyScriptComponent,
    CookieComponent,
    SafeHtmlPipe,
    LegalModalsComponent]
})
export class SharedModule { }
